<template>
  <b-modal
    :id="`approve-order-${orderId}-nfse-modal`"
    :modal-class="'default-modal'"
    header-class="justify-content-between"
    :hide-footer="true"
    @shown="shown"
    @hidden="hidden"
  >

    <template #modal-header="{ close }">
      <div class="text-center">
        <h2 class="highlighted-color1">
          <span>Aprovar nota fiscal</span>
        </h2>
      </div>
      <!--begin::Close-->
      <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close" @click="close()">
          <span class="svg-icon svg-icon-1">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
            </svg>
          </span>
      </div>
      <!--end::Close-->
    </template>

    <AlertWraper
      :content="content"
      :type="content_type"
    />
    <div class="mt-4 text-center">
      <template v-if="loader && !order">
        <div class="text-center">
          <Loader
            :size="'big'"
          />
        </div>
      </template>
      <template v-if="order && invoice">
        <p>Verifique os dados da nota fiscal abaixo antes de aprovar:</p>
        <p class="text-start">
          <strong>Razão Social:</strong> {{ billingName }}<br/>
          <strong>CNPJ:</strong>
          <template v-if="billingDocument.length === 11">
            {{ billingDocument | VMask('###.###.###-##') }}
          </template>
          <template v-else>
            {{ billingDocument | VMask('##.###.###/####-##') }}
          </template>
          <br/>
          <strong>Identificador do pedido:</strong> {{ order.identifier }}<br/>
          <strong>Valor da nota:</strong> {{ invoice.nfse_amount / 100 | formatMoney }}<br/>
          <strong>Valor do imposto (%):</strong> 17,4%<br/>
          <strong>Valor do imposto (R$):</strong> {{ invoice.nfse_amount * 0.174 / 100 | formatMoney }}<br/>
          <strong>Descrição da nota:</strong> {{ invoice.nfse_full_description }}<br/>
          <template v-if="order.insertion_order">
            <strong>Link do PI assinado:</strong> <a :href="order.insertion_order.file" target="_blank">Clique aqui</a>
          </template>
        </p>
        <form class="default-form mb-5" @submit.prevent="" v-if="step === 'refuse'">
          <div class="col-12 mx-auto">
            <div class="">
              <label class="form-label required">Motivo da recusa</label>
              <textarea v-model="form.message" class="form-control" rows="2"></textarea>
            </div>
          </div>
        </form>
        <div class="d-flex justify-content-center mt-4">
          <Button
            type="button"
            class="btn btn-primary me-3"
            @click="submit"
            :loading="loader"
          >
            <span v-if="step === 'init'">Aprovar nota fiscal</span>
            <span v-else-if="step === 'refuse'">Recusar nota fiscal</span>
          </Button>
          <Button
            type="button"
            class="btn btn-danger"
            @click="changeStep('refuse')"
            v-if="step === 'init'"
          >
            Recusar nota fiscal
          </Button>
          <Button
            type="button"
            class="btn btn-danger"
            @click="changeStep('init')"
            v-if="step === 'refuse'"
          >
            Cancelar
          </Button>
        </div>
      </template>
    </div>
  </b-modal>
</template>

<script>

import OrdersService from '@/modules/orders/services/orders-service'
import { parseErrorResponseToArray } from '@/utils'
import { mask } from 'vue-the-mask'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'
import Loader from '@/components/common/Loader/Loader.vue'

export default {
  name: 'ApproveOrderNFSeModal',
  props: ['orderId'],
  directives: { mask },
  components: {
    AlertWraper,
    Button,
    Loader
  },
  data () {
    return {
      content: null,
      content_type: 'error',
      form: {
        is_approved: true,
        message: ''
      },
      loader: false,
      order: null,
      step: 'init'
    }
  },
  computed: {
    /**
     * Billing document
     */
    billingDocument () {
      if (!this.invoice) return ''
      return this.invoice.billing_profile === 'ADVERTISER' ? this.order.advertiser.document : this.order.company.document
    },
    /**
     * Billing name
     */
    billingName () {
      if (!this.invoice) return ''
      return this.invoice.billing_profile === 'ADVERTISER' ? this.order.advertiser.name : this.order.company.name
    },
    /**
     * Invoice
     */
    invoice () {
      return this.order.invoices[0] ?? ''
    }
  },
  methods: {
    /**
     * Change step
     */
    changeStep (step) {
      this.step = step
      if (step === 'init') {
        this.form.message = ''
        this.form.is_approved = true
      } else if (step === 'refuse') {
        this.form.message = ''
        this.form.is_approved = false
      }
    },
    /**
     * Get order
     */
    async getOrder () {
      this.loader = true
      try {
        this.order = await OrdersService.getOrder(this.orderId)
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    /**
     * On modal hidden
     */
    hidden () {
      this.content = null
      this.order = null
      this.step = 'init'
    },
    /**
     * On modal shown
     */
    shown () {
      this.getOrder()
    },
    /**
     * Submit
     */
    async submit () {
      this.loader = true
      this.content = ''
      try {
        const form = Object.assign({}, this.form)
        form.is_approved = form.is_approved ? 1 : 0
        await OrdersService.approveNFSe(this.orderId, form)
        this.$emit('order-nfse-approved', this.order)
        this.$bvModal.hide(`approve-order-${this.orderId}-nfse-modal`)
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    }
  }
}
</script>
